import React, {Component} from 'react';
import {connect} from 'react-redux';

import './language-switcher.scss';
import {changeLanguage} from '../../redux/actions/languageAction';

class LanguageSwitcher extends Component {
  constructor(){
    super();
    this.state = {
      className: 'language-switcher'
    }
  }
  componentWillMount(){
    if(this.props.className && typeof this.props.className === 'string'){
      this.setState({
        className: `language-switcher ${this.props.className}`
      });
    }
  }
  render(){
    const {selected} = this.props.language;
    return(
      <div className={this.state.className}>
        <button
          onClick={() => this.props.changeLanguage('id')}
          className={selected === 'id' ? 'language-active' : 'language-inactive'}>ID</button>
        <button
          onClick={() => this.props.changeLanguage('en')}
          className={selected === 'en' ? 'language-active' : 'language-inactive'}>EN</button>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  language: state.languageReducer
});

const mapDispatchToProps = (dispatch) => ({
  changeLanguage: (type) => dispatch(changeLanguage(type))
});

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSwitcher);
